import { useContext } from 'react';
import {  Container } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ClientUpdateRequest } from 'src/actions';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'src/reducers';
import { Client } from 'src/types/clientTypes';
import MessageContext from 'src/context/MessageContext';
import TopBarForm from 'src/components/shared/TopBarForm';
import { BidForm } from 'src/components/admin/_dashboard/bid';
import { BidSingleRequest, BidUpdateRequest } from 'src/actions/bidActions';
import { Bid } from 'src/types/bidTypes';

export default function EditBid() {
    const { setMessageHandler } = useContext<any>(MessageContext);
    const dispatch = useDispatch();
    const { bidid }: any = useParams<any>();
    const submitForm = async (values: Client, setSubmitting: any) => {
        setTimeout(() => dispatch(BidUpdateRequest(bidid, values, setMessageHandler, setSubmitting)), 200);
    }
    const { bid } = useSelector(state => state.bid);
    var initialValues: Bid = bid

    useEffect(() => {
        dispatch(BidSingleRequest(bidid));
    }, [bidid])

    
    return (
        <Container maxWidth={false}>
            <TopBarForm title="Edit Bid" link="/admin/bid"  />
            <BidForm initialValues={initialValues} submitForm={submitForm} />
        </Container>
    );
}
